import * as React from 'react';
import Popup from 'reactjs-popup';
import * as ReactTooltip from 'react-tooltip';

import { ColorResult } from 'react-color';
import { RectangleIcon } from 'src/App/shared/icons/pt-icon-rectangle';
import { ColorPicker, ColorChangeSource } from 'src/App/shared/components/color-picker.component';

export interface IStrokePickerProps {
    selectedColor: string | undefined;
    recentColors?: string[];
    logoColors?: string[];
    hint?: string;
    onColorChanged:(color: string) => void;
    addPresetColor:(color: string) => void;
}

export interface IStrokePickerState {}

class StrokePickerComponent extends React.Component<IStrokePickerProps, IStrokePickerState> {
    constructor(props: IStrokePickerProps) {
        super(props);

        this.state = {
            selectedColor: '#000'
        };
    }

    private handleChangeComplete(color: ColorResult, source: ColorChangeSource, closeFn:() => void) {
        if (source === ColorChangeSource.Preset) {
            this.props.addPresetColor(color.hex)
            closeFn();
        }
        this.props.onColorChanged(color.hex);
    }

    private handleClose() {
        if (this.props.selectedColor) {
            this.props.addPresetColor(this.props.selectedColor)
        }
    }

    public render() {
        return (
            <Popup
                trigger={(open) => (
                    <button
                        className="stroke-picker-btn"
                        data-tip={this.props.hint}
                    >
                        <ReactTooltip effect={'solid'} />
                        <RectangleIcon strokeColor={this.props.selectedColor} />
                    </button>
                )}
                contentStyle={{ width: 'auto', padding: 0, borderRadius: '4px' }}
                position="top left"
                closeOnDocumentClick={true}
                onClose={() => this.handleClose()}
            >
             {closeFn => (
                <div className="stroke-picker-popup">
                    <ColorPicker
                        color={ this.props.selectedColor }
                        recentColors={this.props.recentColors}
                        logoColors={this.props.logoColors}
                        onChangeComplete={(color, source) => this.handleChangeComplete(color, source, closeFn)}
                    />
                </div>
             )}
            </Popup>
        )
    }
}

export const StrokePicker = (props: IStrokePickerProps) => <StrokePickerComponent {...props} />



// WEBPACK FOOTER //
// ./src/App/logo-app/logo-editor/logo-editor-controls/stroke-picker.component.tsx